import { CreateMetaplanRequestDto } from '@tiendanube/common';
import { SubscriptionFrequencyTypeEnum } from '@tiendanube/common/src/domains/subscriptions/enums';

export const getMetaplanDefault = (): CreateMetaplanRequestDto => ({
  name: '',
  productIds: [],
  subscriptionOptions: [
    {
      frequencyType: SubscriptionFrequencyTypeEnum.EVERY_N_DAYS,
      frequencyParam: '0',
      discountPercentage: 0,
    },
  ],
  promotionCombinations: {
    combinesWithPriceDiscounts: false,
    combinesWithQuantityDiscounts: false,
    combinesWithFreeShipping: false,
    combinesWithCartAmountDiscounts: false,
    combinesWithAppDiscounts: false,
  },
  isSubscriptionOnly: false,
});
